/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

/**
 *  Footer locale / currency switcher — custom dropdown (opens upward) wrapping
 *  Shopify's native localization form. Each menu option is now a real
 *  <button type="submit" name="locale_code|country_code" value="…">, so selecting
 *  one submits the native form directly — Shopify's auto return_to then redirects
 *  to the equivalent localized URL of the current page. This JS ONLY opens/closes
 *  the dropdown; it no longer touches a hidden input or submit the form (so a JS
 *  hiccup can't block the actual language/currency switch once the menu is open).
 */
document.querySelectorAll('[data-locale-switcher]').forEach((root) => {
  const trigger = root.querySelector('.footer__lang-trigger');
  const menu = root.querySelector('.footer__lang-menu');
  if (!trigger || !menu) return;

  const close = () => {
    root.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  };
  const open = () => {
    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  };

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    root.classList.contains('is-open') ? close() : open();
  });

  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
});